const KeyTrad_NumberPerPage = {
  Student: "number_student_per_page",
  Training: "number_training_per_page",
};

export default KeyTrad_NumberPerPage;
